import { ReactNode, useMemo } from "react";
import Dialog from "@mui/material/Dialog";
import { Box, Button, DialogContent, Divider, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import DialogActions from "@mui/material/DialogActions";
import { WarningAmber } from "@mui/icons-material";

interface ApprovalDialogProps {
    variant?: 'default' | 'warning',
    open: boolean;
    title: string;
    content?: ReactNode;
    icon?: ReactNode;
    declineButtonLabel?: string;
    approveButtonLabel?: string;
    onDecline: () => void;
    onApprove: () => void;
}

export default function ApprovalDialog({ variant = 'default', content, open, title, icon, onDecline, onApprove, declineButtonLabel, approveButtonLabel }: ApprovalDialogProps) {

    const variantIcon = useMemo(() => {

        let actualIcon: ReactNode | undefined = icon;

        if (!actualIcon) {
            switch (variant) {
                case "warning":
                    actualIcon = <WarningAmber sx={{  fontSize: 32 }} color="warning" />
            }
        }

        if (!actualIcon) return null;

        return (
            <Box
                justifyContent="center"
                sx={{
                    display: 'flex',
                    flex: '1 1 auto',
                    px: 2,
                    pt: 2
                }}
            >
                <Divider sx={{ display: 'flex', flex: '1 1 auto' }}>
                    {actualIcon}
                </Divider>
            </Box>
        )

    }, [icon, variant])

    return (
        <Dialog open={open}>
            <DialogContent>
                {variantIcon}
                <Grid container spacing={2} alignContent="center" sx={{ px: 4, py: 2 }}>
                    <Grid size="grow" alignContent="center">
                    <Stack spacing={2}>
                        <Typography variant="h6" component="p" sx={{ textAlign: 'center' }}>{title}</Typography>
                        <Box sx={{ textAlign: 'center' }}>{content}</Box>
                    </Stack>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', p: 2 }}>
                <Button
                    color="success"
                    variant="contained"
                    onClick={onDecline}
                >
                    {declineButtonLabel || "Abbrechen"}
                </Button>
                <Button
                    color="error"
                    variant="outlined"
                    onClick={onApprove}
                >
                    { approveButtonLabel || "Bestätigen!"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}